/**
 * The homepage renders the logged-out variant; with a session every
 * `[data-auth="in"]` element is shown and every `[data-auth="out"]` hidden,
 * in one pass (#508).
 */
export function applyAuthState(root: ParentNode, loggedIn: boolean): void {
  for (const el of root.querySelectorAll<HTMLElement>("[data-auth]")) {
    const show = (el.dataset.auth === "in") === loggedIn;
    el.classList.toggle("hidden", !show);
  }
}
